module.exports = __webpack_public_path__ + "img/logo_feuille_tricolore.378e74d0.png";